/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Remove_Button1Inputs */

const en_coinvestments_prospects_remove_button1 = /** @type {(inputs: Coinvestments_Prospects_Remove_Button1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Coinvestments_Prospects_Remove_Button1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_remove_button1 = /** @type {((inputs?: Coinvestments_Prospects_Remove_Button1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Remove_Button1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_remove_button1(inputs)
});
export { coinvestments_prospects_remove_button1 as "coInvestments_prospects_remove_button" }